<template>
  <label path="storeid">{{ label }} <span class="red" v-if="requiredIcon">*</span></label>
  <!-- <InputText :disabled="disabled" :maxlength="maxlength" v-model="model" :type="txttype" :id="id" :name="name"
    @blur="handleBlur" :class="{ 'p-invalid': errorMessages.length, 'numeric-class': isNumeric }" @input="InputChk"
    @change="$emit('change')" ref="inputField" :placeholder="placeholder" @keyup="$emit('keyup')"
    :autocomplete="autocomplete" :tabindex="tabindex" @click="$emit('click')" :readonly="readonly"
    @focus="$emit('focus')" @keyup.enter="$emit('keyupenter')" :autofocus="autofocus" /> -->
  <div :class="{ 'email-wrapper': txttype === 'email' }"
    :data-form-type="txttype === 'email' ? 'email-no-autofill' : 'other'" data-lpignore="true">
    <InputText :disabled="disabled" :maxlength="maxlength" v-model="model" :type="txttype" :id="id"
      :name="name + '_' + Math.random().toString(36).substring(2, 15)" autocomplete="new-password"
      :style="{ 'background-image': 'none !important' }" @blur="handleBlur"
      :class="{ 'p-invalid': errorMessages.length, 'numeric-class': isNumeric }" @input="InputChk"
      @change="$emit('change')" ref="inputField" :placeholder="placeholder" @keyup="$emit('keyup')" :tabindex="tabindex"
      @click="$emit('click')" :readonly="readonly" @focus="$emit('focus')" @keyup.enter="$emit('keyupenter')"
      :autofocus="autofocus" />
  </div>
  <p v-if="errorMessages.length" class="err_msg_style">
    {{ errorMessages[0] }}
  </p>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  reactive,
  toRefs,
  onMounted,
  computed,
  nextTick,
  watch,
} from "vue";
import { useField, defineRule, configure, validate } from "vee-validate";
import { required, email } from "@vee-validate/rules";
import InputText from "primevue/inputtext";

type Messages = {
  [key: string]: string;
};

configure({
  generateMessage: function (ctx) {
    const messages: Messages = {
      required: `${ctx.field} is required`,
    };
    const message =
      messages[ctx.rule?.name ?? ""] ||
      `Please enter a valid value for ${ctx.field}.`;
    return message;
  },
});

defineRule("website", (value) => {
  if (!value || !value.length) {
    return true;
  }
  const urlPattern =
    /^(https?:\/\/(www\.)?)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+([/?].*)?$/;
  if (!urlPattern.test(value)) {
    return "This field must be a valid website";
  }
  return true;
});

defineRule("nonnegative", (value) => {
  if (value < 0) {
    return "This field accepts only positive numbers";
  }
  return true;
});

defineRule("email", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
    return "This field must be a valid email";
  }
  return true;
});

defineRule("Phonenumber", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (value.length > 10 || value.length < 10) {
    return "Invalid Phone Number";
  }
  if (!/^\d+$/.test(value)) {
    return "This field must be numeric";
  }
  return true;
});

defineRule("Phonenumber1", (value) => {
  if (!value || !value.length) {
    return true;
  }

  // Remove spaces for validation
  const cleanValue = value.replace(/\s/g, '');

  // Check if it starts with +91 followed by 10 digits
  if (cleanValue.startsWith('+91')) {
    const digitsAfterPrefix = cleanValue.substring(3);
    if (digitsAfterPrefix.length !== 10) {
      return "Phone number must be 10 digits after +91";
    }
    if (!/^\d+$/.test(digitsAfterPrefix)) {
      return "Phone number must contain only digits after +91";
    }
  } else {
    // Regular 10 digit number
    if (cleanValue.length !== 10) {
      return "Phone number must be exactly 10 digits";
    }
    if (!/^\d+$/.test(cleanValue)) {
      return "Phone number must contain only digits";
    }
  }
  return true;
});

defineRule("Pannumber", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (value.length !== 10) {
    return "PAN number must be exactly 10 characters long";
  }
  const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  if (!panPattern.test(value)) {
    return "Invalid PAN number format";
  }
  const typeChar = value.charAt(3);
  const validTypes = ["P", "C", "H", "A", "B", "G", "J", "L", "F", "T"];
  if (!validTypes.includes(typeChar)) {
    return `Invalid PAN number: fourth character must be one of ${validTypes.join(
      ", "
    )}`;
  }
  return true;
});

defineRule("HeightRange", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (value < 30 || value > 250) {
    return "Invalid Height";
  }
  return true;
});

defineRule("WeightRange", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (value < 1 || value > 300) {
    return "Invalid Weight";
  }
  return true;
});

defineRule("Aadharnumber", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (value.length != 12) {
    return "Invalid Aadhar Number";
  }
  return true;
});

defineRule("numeric", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (!/^\d+$/.test(value)) {
    return "This field must be numeric";
  }
  return true;
});

defineRule("landlinevalid", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (!/^\d+$/.test(value)) {
    return "This field must be numeric";
  }
  return true;
});

defineRule("decimalnumeric", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (!/^\d*\.?\d+$/.test(value)) {
    return "This field must be a valid number";
  }
  return true;
});

defineRule("percentage", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (!/^\d*\.?\d+$/.test(value)) {
    return "This field must be a valid number";
  }
  const numericValue = parseFloat(value);
  if (numericValue < 0 || numericValue > 100) {
    return "This field must be between 0 and 100";
  }
  return true;
});

defineRule("decimalnumber", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (!/^\d*\.?\d{0,2}$/.test(value)) {
    return "This field must be a valid number with up to two decimal places";
  }
  return true;
});

defineRule("decimal", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (!/^(\d*\.)?\d+$/.test(value)) {
    return "This field must be decimal";
  }
  return true;
});

defineRule("alphanumeric", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (!/^[a-zA-Z0-9 ]+$/.test(value)) {
    return "This field must be alphanumeric";
  }
  return true;
});

defineRule("alphabet", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (!/^[a-zA-Z ]+$/.test(value)) {
    return "This field must be alphabets";
  }
  return true;
});

defineRule("nonzeroable", (value) => {
  if (value == 0) {
    return "This field must be greater than zero";
  }
  return true;
});

defineRule("foureigtValid", (value) => {
  if (value.length != 4 && value.length != 8) {
    return "This field must have 4 Character or 8 Character";
  }
  return true;
});

defineRule("twodigitValid", (value) => {
  if (value.length > 2) {
    return "This field must have 2 Character ";
  }
  return true;
});

defineRule("twelveDigitValid", (value) => {
  if (value.length > 12) {
    return "This field must have 12 Characters or less than 12 Characters";
  }
  return true;
});

defineRule("password", (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (
    !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d@$!%*?&]{8,}$/.test(
      value
    )
  ) {
    return "Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character, with a minimum length of 8 characters";
  }
  return true;
});

export default defineComponent({
  props: {
    value: {},
    id: {
      type: String,
      default: "",
    },
    txttype: {
      type: String,
      default: "text",
    },
    input: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    rules: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
    modelValue: {
      type: String,
      default: "",
    },
    autocomplete: {
      type: String,
      default: "off",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
    },
    tabindex: {
      type: Number,
    },
    case: {
      type: String,
      default: "",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const model = ref();

    onMounted(() => {
      model.value = props.modelValue;
      update();
    });

    watch(
      () => props.modelValue,
      (newVal) => {
        model.value = newVal;
        update();
      }
    );

    function update() {
      emit("update:modelValue", model);
    }

    const { value, errorMessage, handleBlur, meta } = useField(
      props.name,
      props.rules,
      { initialValue: props.modelValue }
    );

    const errorMessages = computed(() => {
      return errorMessage.value ? [errorMessage.value] : [];
    });
    // First, add this interface to define the InputText ref type
    interface InputTextRef {
      $el: HTMLInputElement;
    }

    const inputField = ref<InputTextRef | null>(null);
    // Update the watch section
    // watch(
    //   () => meta.valid,
    //   (isValid) => {
    //     if (!isValid && props.rules?.required) {
    //       nextTick(() => {
    //         console.log("Input field ref:", inputField.value); // Debug what the ref contains
    //         console.log("Input field $el:", inputField.value?.$el); // Debug the $el property

    //         try {
    //           const inputElement =
    //             inputField.value?.$el?.querySelector("input");
    //           console.log("Found input element:", inputElement); // Debug the found input element

    //           if (inputElement instanceof HTMLInputElement) {
    //             inputElement.focus();
    //           } else {
    //             console.warn(
    //               "Input element is not an HTMLInputElement:",
    //               inputElement
    //             );
    //           }
    //         } catch (error) {
    //           console.error("Error while trying to focus:", error);
    //         }
    //       });
    //     }
    //   }
    // );
    watch(
      () => meta.valid,
      (isValid) => {
        if (!isValid && props.rules?.required) {
          nextTick(() => {
            console.log("Input field ref:", inputField.value);
            console.log("Input field $el:", inputField.value?.$el);

            try {
              const inputElement = inputField.value?.$el?.querySelector("input");
              console.log("Found input element:", inputElement);

              if (inputElement instanceof HTMLInputElement) {
                const inputValue = inputElement.value;

                // Check regex pattern validation if pattern rule exists
                if (props.rules?.pattern && inputValue) {
                  let regex;
                  try {
                    // Handle both string pattern and RegExp object
                    if (typeof props.rules.pattern === 'string') {
                      // Remove the leading and trailing slashes if present
                      const patternString = props.rules.pattern.replace(/^\/|\/$/g, '');
                      regex = new RegExp(patternString);
                    } else {
                      regex = props.rules.pattern;
                    }

                    console.log("Testing regex:", regex, "against value:", inputValue);

                    if (!regex.test(inputValue)) {
                      console.log("Regex validation failed");
                      inputElement.focus();
                      return;
                    }
                  } catch (regexError) {
                    console.error("Invalid regex pattern:", props.rules.pattern, regexError);
                  }
                }

                // Focus only if required field is empty
                if (props.rules?.required && !inputValue?.trim()) {
                  console.log("Required field validation failed");
                  inputElement.focus();
                }
              } else {
                console.warn(
                  "Input element is not an HTMLInputElement:",
                  inputElement
                );
              }
            } catch (error) {
              console.error("Error while trying to focus:", error);
            }
          });
        }
      }
    );
    const cursorPosition = ref(0);

    function InputChk(event) {
      const input = event.target;
      cursorPosition.value = input.selectionStart || 0;

      let newValue = model.value;
      if (props.case == "Capital") {
        newValue = model.value.toUpperCase();
      } else if (props.case == "Lower") {
        newValue = model.value.toLowerCase();
      }

      emit("update:modelValue", newValue);

      nextTick(() => {
        input.setSelectionRange(cursorPosition.value, cursorPosition.value);
      });
    }

    const isNumeric = computed(() => {
      return props.rules && props.rules.numeric === true;
    });

    const formattedModel = computed({
      get() {
        if (isNumeric.value) {
          return formatNumberWithCommas(model.value);
        }
        return model.value;
      },
      set(newValue) {
        model.value = newValue.replace(/,/g, "");
        emit("update:modelValue", model.value);
      },
    });

    function formatNumberWithCommas(value) {
      if (!value) {
        return "";
      }
      const cleanedValue = value.replace(/[^\d.]/g, "");
      const [integerPart, decimalPart] = cleanedValue.split(".");
      const formattedIntegerPart = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ","
      );
      return decimalPart
        ? `${formattedIntegerPart}.${decimalPart}`
        : formattedIntegerPart;
    }

    return {
      InputChk,
      value,
      errorMessages,
      handleBlur,
      model,
      update,
      isNumeric,
      formattedModel,
      inputField,
    };
  },
});
</script>

<style lang="scss">
.numeric-class {
  text-align: end;
}

.numeric-class::placeholder {
  text-align: start;
}
</style>
<!-- 56789 -->
